import unicodeToGsm from './gsm.json';
import big5Unicode from './big5_2003-u2b.json';
const big5UnicodeSet = new Set(big5Unicode);
export default class CharCodeUtil {
  static isHighSurrogate(c) {
    var codeUnit = c.charCodeAt != undefined ? c.charCodeAt(0) : c;
    return codeUnit >= 0xd800 && codeUnit <= 0xdbff;
  }
  static unicodeCodePoints(string) {
    var charCodes = Array.from(string).map(function(x) {
      return x.charCodeAt(0);
    });
    var result = [];
    while (charCodes.length > 0) {
      if (this.isHighSurrogate(charCodes[0])) {
        var high = charCodes.shift();
        var low = charCodes.shift();
        result.push((high - 0xd800) * 0x400 + (low - 0xdc00) + 0x10000);
      } else {
        result.push(charCodes.shift());
      }
    }
    return result;
  }
  static isGSMEncode(s) {
    // choose gsm if possible otherwise ucs2
    if (
      this.unicodeCodePoints(s).every(function(x) {
        return x in unicodeToGsm;
      })
    ) {
      return true;
    } else {
      return false;
    }
  }
  static isBig5(s) {
    if (
      this.unicodeCodePoints(s).every(function(x) {
        return big5UnicodeSet.has(`0x${x.toString(16).toUpperCase()}`);
      })
    ) {
      return true;
    } else {
      return false;
    }
  }
}
